import {createTheme} from '@mui/material'
import './index.scss'
import {Shadows} from '@mui/material/styles/shadows'


const montserrat = [
  'Montserrat',
  '-apple-system',
  'sans-serif',
].join(',')

const neueMachina = [
  'Neue Machina',
  '-apple-system',
  'sans-serif',
].join(',')

const brandBlack = '#2B242F'
const brandWhite = '#FFD9D6'

const rootTheme = createTheme({
  typography: {
    fontFamily: neueMachina,

    h1: {
      fontFamily: montserrat,
      fontSize: '38px',
      fontWeight: 900,
      lineHeight: .9,
      fontStyle: 'italic',
      textTransform: 'uppercase',
      textAlign: 'center',
    },
    h2: {
      fontFamily: neueMachina,
      fontSize: '24px',
      lineHeight: 1.3,
      textTransform: 'uppercase',
      textAlign: 'center',
    },
    subtitle1: {
      fontFamily: neueMachina,
      fontSize: '17px',
      lineHeight: 1.3,
      textAlign: 'center',
      fontStyle: 'normal',
    },
    body1: {
      fontFamily: neueMachina,
      fontSize: '15px',
      lineHeight: 1.3,
      fontStyle: 'normal',
      textTransform: 'none',
    },
    body2: {
      fontFamily: neueMachina,
      fontSize: '8px',
      fontStyle: 'normal',
    },
    button: {
      fontFamily: montserrat,
      fontSize: '21.45px',
      fontWeight: 900,
      lineHeight: 1.3,
      fontStyle: 'italic',
      textTransform: 'uppercase',
    },
  },

  palette: {
    divider: brandBlack,
    common: {
      black: brandBlack,
      white: brandWhite,
    }
  },

  spacing: 4,

  shadows: [
    'none',
    ...Array.from({length: 24}).map((_, i) => `0 0 ${i * 4}px rgba(0, 0, 0, 0.35)`),
  ] as Shadows,

  components: {
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
      },
    },
    MuiButton: {
      defaultProps: {
        disableRipple: true,
        variant: 'outlined',
        color: 'inherit',
      },
      styleOverrides: {
        root: {
          flexDirection: 'column',
          borderRadius: 70,
          minWidth: 150,
          minHeight: 64,
          paddingTop: 8,
          paddingBottom: 8,
          paddingLeft: 24,
          paddingRight: 24,
          borderWidth: '1px',
          boxSizing: 'border-box',
          boxShadow: 'none',

          '&:hover': {
            boxShadow: 'none',
          },

          '&.MuiButton-contained': {
            backgroundColor: brandBlack,
            color: brandWhite,

            '&:hover': {
              backgroundColor: brandBlack,
            },
          },
        },
      },
    },
    MuiLink: {
      defaultProps: {
        color: 'common.black',
      },
    },
  },
})

export default rootTheme
